import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ArrowRight } from "lucide-react";
import { QUALITY_PREVIEW } from "../portalPreviewData";

const SEVERITY_COLOR = {
  high: "bg-red-100 text-red-700 border-red-200",
  medium: "bg-amber-100 text-amber-700 border-amber-200",
  low: "bg-slate-100 text-slate-600 border-slate-200",
};

export default function QualityOverviewPreview() {
  const { tagline, chain, stats, recentGaps } = QUALITY_PREVIEW;

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-bold text-foreground">Quality Overview</h2>
        <p className="text-sm text-muted-foreground">{tagline}</p>
      </div>

      <div className="flex flex-wrap items-center gap-2 p-4 rounded-xl border border-border bg-muted/30">
        {chain.map((step, i) => (
          <React.Fragment key={step}>
            <span className="text-sm font-medium px-3 py-1.5 rounded-full bg-card border border-border">{step}</span>
            {i < chain.length - 1 && <ArrowRight className="w-3.5 h-3.5 text-muted-foreground" />}
          </React.Fragment>
        ))}
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {stats.map((s) => (
          <Card key={s.label} data-navigator-id={s.id}>
            <CardContent className="pt-5">
              <p className="text-2xl font-bold text-foreground">{s.value}</p>
              <p className="text-xs text-muted-foreground mt-1">{s.label}</p>
            </CardContent>
          </Card>
        ))}
      </div>

      <Card>
        <CardContent className="pt-5 space-y-2.5">
          <p className="text-sm font-semibold text-foreground mb-1">Most recent open gaps</p>
          {recentGaps.map((g) => (
            <div key={g.id} className="flex items-center justify-between gap-3 text-sm p-2.5 rounded-lg border border-border/60">
              <div className="min-w-0">
                <p className="text-foreground font-medium">{g.id} — {g.requirement}</p>
                <p className="text-[11px] text-muted-foreground">Process: {g.process}</p>
              </div>
              <Badge className={`text-[10px] border ${SEVERITY_COLOR[g.severity]}`} variant="outline">
                {g.severity}
              </Badge>
            </div>
          ))}
        </CardContent>
      </Card>
    </div>
  );
}
